import { render, staticRenderFns } from "./IMTeamAnnouncementComponent.vue?vue&type=template&id=0ef4f536&"
import script from "./IMTeamAnnouncementComponent.vue?vue&type=script&lang=js&"
export * from "./IMTeamAnnouncementComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports